<form [formGroup]="userForm" (ngSubmit)="onSubmit()">
  
  <div>
    <label>ID:</label>
    <input type="number" formControlName="id" />
  </div>

  <div>
    <label>Username:</label>
    <input type="text" formControlName="username" />
  </div>

  <div>
    <label>Password:</label>
    <input type="password" formControlName="password" />
  </div>

  <div>
    <label>First Name:</label>
    <input type="text" formControlName="firstName" />
  </div>

  <div>
    <label>Last Name:</label>
    <input type="text" formControlName="lastName" />
  </div>

  <div>
    <label>User Badge:</label>
    <input type="text" formControlName="userBadge" />
  </div>

  <div>
    <label>Balance:</label>
    <input type="number" formControlName="balance" step="0.01" />
  </div>

  <div>
    <label>Email:</label>
    <input type="email" formControlName="email" />
  </div>

  <div>
    <label>Role:</label>
    <select formControlName="role">
      <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
    </select>
  </div>

  <div>
    <label>Address:</label>
    <input type="text" formControlName="address" />
  </div>

  <div>
    <label>Service Area (comma separated):</label>
    <!-- <input type="text" (change)="userForm.controls['serviceArea'].setValue($event.target.value.split(','))" /> -->
    <input type="text"
       formControlName="serviceAreaText"
       (input)="updateServiceArea()" />
  </div>

  <div>
    <label>Services (comma separated):</label>
      <!--<input type="text" (change)="userForm.controls['services'].setValue($event.target.value.split(','))" /> -->
        <input type="text"
       formControlName="serviceAreaText"
       (input)="updateServices()" />
  </div>

  <div>
    <label>Rating:</label>
    <input type="number" step="0.1" formControlName="rating" />
  </div>

  <div>
    <label>Profile Image URL:</label>
    <input type="text" formControlName="profileImage" />
  </div>

  <div>
    <label>Referred By:</label>
    <input type="text" formControlName="referredBy" />
  </div>

  <button type="submit" [disabled]="userForm.invalid">Create User</button>
</form>
